import React from 'react'
import {push} from './history'

const Link = ({to, children, onActivate, ...props}) => {
    const onClick = (e) => {
    	const aNewTab = e.metaKey || e.ctrlKey;
        const anExternalLink = to.indexOf('http')===0;

        if (!aNewTab && !anExternalLink) {
            e.preventDefault();
            if (onActivate) onActivate()
            push(to);
        }
    }
    return (
        <a href={to} onClick={onClick} {...props}>
            {children}
        </a>
    );
}

export default Link


// WEBPACK FOOTER //
// ./src/fm/lib/Link.js